import axios from 'axios';
import { loaderAction } from "../actions";
export const userService = {
    login,
};

function login(userName, password) {
    try {
        const requestUser = { "userName": userName, "password": password }
        const response = axios.post( process.env.REACT_APP_SERVER_URL + "v1/userresource/auth/login", requestUser)
            .then(user => {
                const userData = user.data.data.response;
                localStorage.setItem('user', JSON.stringify(userData));
                localStorage.setItem('accessToken', userData.accessToken);
                return user;
            })
        return response
    }
    catch (error) {
        throw error;
    }
}